var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4213 25.153C11.174 24.6619 9.0808 23.766 7.21663 22.5465C7.21747 22.5449 7.2183 22.5433 7.21913 22.5417C5.77156 25.3255 4.67938 27.8601 4.04264 29.8007C3.47432 31.5328 2.97372 33.429 4.61499 30.4049C5.58904 28.6102 7.98533 26.0911 13.4213 25.153Z",
    fill: "#6160A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2168 22.5465C7.94943 21.1373 8.77316 19.6642 9.67501 18.1719C11.7582 19.6059 14.2466 20.4781 16.9293 20.5744C16.6591 20.5706 16.384 20.5567 16.104 20.5321C19.316 21.5328 21.0132 20.8711 22.2722 20.3804C22.4323 20.3179 22.5853 20.2583 22.7334 20.2052C19.8854 23.4418 18.0257 24.3932 13.5847 25.1255C13.53 25.1346 13.4756 25.1437 13.4216 25.1531C11.1742 24.6619 9.08099 23.766 7.2168 22.5465Z",
    fill: "#90DF9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67188 18.178C14.1477 10.7702 20.5489 2.88725 27.2877 0C28.0118 0.915404 28.8683 3.48578 28.3336 6.27776C27.4165 11.0674 23.6029 13.9431 19.0814 13.8293C19.8162 14.2162 22.6214 15.2685 25.9361 13.7646C24.6095 17.9194 21.2523 20.8623 16.3818 20.5531C13.9067 20.365 11.6132 19.5155 9.67188 18.178Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather);
export default __webpack_public_path__ + "static/media/feather.f47293479fa6323b92edaed1a36a0b41.svg";
export { ForwardRef as ReactComponent };